import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetPortfolioEventCardsByCategoryUidApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            category: z.object({
                documentId: z.string(),
                name: z.string(),
                slug: z.string(),
            }),
            slug: z.string(),
        }),
    ),
});

type GetPortfolioEventCardsByCategoryUidApiResponse
    = ApiResponse<z.infer<typeof GetPortfolioEventCardsByCategoryUidApiResponseSchema>>
    | BaseError;

type GetPortfolioEventCardsByCategoryUidActionRequest = {
    uid: string
}

export const getPortfolioEventCardsByCategoryUid = createAsyncThunk<
    GetPortfolioEventCardsByCategoryUidApiResponse,
    GetPortfolioEventCardsByCategoryUidActionRequest
>(
    'PortfolioEventsPageActionsGetPortfolioEventCardsByCategoryUid',
    async ({
        uid,
    }) => apiInstance.get(
        '/portfolio-events',
        {
            'filters[category][slug][$eq]': uid,
            'populate[images][fields]': 'url',
            'populate[category][fields]': '*',
        },
        GetPortfolioEventCardsByCategoryUidApiResponseSchema,
    ),
);
